<template>
  <div class="flex flex-1 flex-column">
    <u-header>
      <span v-if="!selectionMode" class="gift icon-chart" slot="left" @click="$router.push('/statistics')"></span>
      <span v-else class="gift icon-cross" slot="left" @click="cancel"></span>
      {{selectionMode?'多选':'礼钱管家'}}
      <span v-if="!selectionMode" class="gift icon-plus" slot="right" @click="pop.show=true">
        <div class="popup" v-show="pop.show" v-clickoutside="()=>pop.show=false">
          <router-link class="command t-c" to="/add-history?type=sent">我又支出了</router-link>
          <router-link class="command t-c" to="/add-history?type=received">我又收到了</router-link>
        </div>
      </span>
      <span v-else class="gift icon-zhengque" slot="right" @click="multiRemove"></span>
    </u-header>
    <u-tabs class="tabs flex flex-1" v-model="path">
      <u-tab label="我送出的" value="sent">
        <p-sent :selections="selections.sent" :multi="selectionMode&&path==='sent'"
          @change="onSentSelectionChange" @longpress="enterMultiSelection"></p-sent>
      </u-tab>
      <u-tab label="我收到的" value="received">
        <p-received :selections="selections.received" :multi="selectionMode&&path==='received'"
          @change="onReceivedSelectionChange" @longpress="enterMultiSelection"></p-received>
      </u-tab>
    </u-tabs>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      path: 'sent',
      pop: {
        show: false
      },
      selections: {
        sent: [],
        received: []
      },
      selectionMode: false
    }
  },
  components: {
    'p-sent': () => import('@/views/Sent.vue'),
    'p-received': () => import('@/views/Received.vue')
  },
  methods: {
    ...mapActions(['removeHistories']),
    cancel () {
      this.selectionMode = false
      this.selections.sent = []
      this.selections.received = []
    },
    enterMultiSelection (item) {
      this.selectionMode = true
    },
    onSentSelectionChange (history, checked) {
      const index = this.selections.sent.indexOf(history)
      if (index > -1) {
        this.selections.sent.splice(index, 1)
      } else {
        this.selections.sent.push(history)
      }
    },
    onReceivedSelectionChange (history, checked) {
      const index = this.selections.received.indexOf(history)
      if (index > -1) {
        this.selections.received.splice(index, 1)
      } else {
        this.selections.received.push(history)
      }
    },
    multiRemove () {
      this.$confirm('谨慎操作', `确认要删除所选的${this.path === 'sent' ? this.selections.sent.length : this.selections.received.length}条${this.path === 'sent' ? '支出' : '收入'}记录么？该操作将删除数据，请谨慎操作！`).then(() => {
        return this.removeHistories([this.path, this.selections[this.path]])
      }).then(() => {
        this.$toast('记录已成功删除')
        this.cancel()
      }).catch(() => {})
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "../components/var.styl"
.icon-plus
  position relative
  .popup
    position absolute
    top 28px
    right -4px
    width 100px
    background-color #fff
    border-radius 4px
    box-shadow 0 0 6px rgba(0, 0, 0, .15)
    z-index 20
    &::before
    &::after
      content ''
      position absolute
      right 6px
      top -12px
      border-width 7px
      border-style solid
      z-index 10
    &::before
      margin-top -1px
      border-color transparent transparent #eee transparent
    &::after
      border-color transparent transparent #fff transparent
    .command
      display block
      padding 10px 0
      color $color-text-primary
      font-size 12px
      &:first-child
        border-bottom 1px solid $color-disabled
      &:active
        color $color-text-highlight
</style>



// WEBPACK FOOTER //
// Home.vue?358daf2e